import React, { useState, useEffect } from "react";
import { Link, Redirect } from 'react-router-dom';

import {

  Grid,

  Button,

  Typography,

  Paper,

  Table,

  TableHead,

  TableBody,

  TableRow,

  TableCell,

} from "@material-ui/core";

import {

  KeyboardDatePicker,

  MuiPickersUtilsProvider,

} from "@material-ui/pickers";

import MomentUtils from "@date-io/moment";

import moment from "moment";

import axios from "axios";
 
export default function GetCounts() {

  const [fromDate, setFromDate] = useState(moment());

  const [toDate, setToDate] = useState(moment());

  const [data, setData] = useState([]);
 
  const fetchData = async (from, to) => {

    try {

      const formattedFrom = moment(from).format("YYYY-MM-DD");

      const formattedTo = moment(to).format("YYYY-MM-DD");
 
      const url = `https://ekyc.chili.mu:9443/api/shop/activation/agent/5570/counts/verified?from=${formattedFrom}&to=${formattedTo}`;

      const response = await axios.get(url);
      let datacount = response.data?.data?.dates || {}
      const sortedByDateAsc = Object.entries(datacount).sort(
        (a, b) => new Date(b[0]) - new Date(a[0])
    );

      // Convert back to object (optional)
      const sortedDates = Object.fromEntries(sortedByDateAsc);
           
           console.log("data--->>",sortedDates)

      setData(sortedDates);

    } catch (error) {

      console.error("API error:", error);

      setData({});

    }

  };
 
  useEffect(() => {

    fetchData(fromDate, toDate); 

  }, []);
 
  const handleFetch = () => {

    fetchData(fromDate, toDate);

  };
 
  return (
    <div className="Auth-container" style={{ textAlign: 'center' }}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
      
      
      <h3 style={{ color: 'Gray' }}>Verified Activation Count</h3>
      
              <Grid container spacing={3} alignItems="center">
      <Grid item xs={12} sm={4}>
      <KeyboardDatePicker

                    margin="normal"

                    label="From Date"

                    format="YYYY-MM-DD"

                    value={fromDate}

                    onChange={setFromDate}

                    fullWidth

                  />
      </Grid>
      <Grid item xs={12} sm={4}>
      <KeyboardDatePicker

                    margin="normal"

                    label="To Date"

                    format="YYYY-MM-DD"

                    value={toDate}

                    onChange={setToDate}

                    fullWidth

                  />
      </Grid>
      <Grid item xs={12} sm={4}>
      <button
          className="button_id"
                    fullWidth

                    variant="contained"

                    color="primary"

                    onClick={handleFetch}

                    style={{ fontSize: 16, width: 120, padding: 10 }}
      >

                    Fetch Data
      </button>
      <button
          className="button_id"
                    fullWidth

                    variant="contained"

                    color="primary"

                    

                    style={{ fontSize: 16, width: 120, padding: 10 }}
      >

<Link to="/choosecustomer" className="link1">Back</Link>
      </button>
      </Grid>
      </Grid>
      
              
      <h3 style={{ color: 'Gray',marginTop: 32  }}>Activation Counts by Date</h3>

      
              <Table style={{ marginTop: 16 }}>
      <TableHead>
      <TableRow>
      <TableCell><strong>Date</strong></TableCell>
      <TableCell><strong>Count</strong></TableCell>
      </TableRow>
      </TableHead>
      <TableBody>

                  {Object.keys(data).length === 0 ? (
      <TableRow>
      <TableCell colSpan={2} align="center">

                        No Records Found
      </TableCell>
      </TableRow>

                  ) : (

                    Object.entries(data).map(([date, count]) => (
      <TableRow key={date}>
      <TableCell>{date}</TableCell>
      <TableCell>{count}</TableCell>
      </TableRow>

                    ))

                  )}
      </TableBody>
      </Table>
      
      </MuiPickersUtilsProvider>
      </div>
  );

}

 